// ============================================================
// Domain — Country / currency reference data
// ============================================================

// Region timezone offsets. Used alongside COUNTRY_TZ_ABBR which provides the
// locale-specific abbreviation (SGT / MYT / ICT / …) that the prototype
// shows next to the offset. Fallback only — the API's countryConfig wins.
export const COUNTRY_TZ: Record<string, string> = {
  SG: 'UTC+8',
  MY: 'UTC+8',
  ID: 'UTC+7',
  TH: 'UTC+7',
  VN: 'UTC+7',
  PH: 'UTC+8',
  TW: 'UTC+8',
  AU: 'UTC+11',
  KR: 'UTC+9',
};

export const COUNTRY_TZ_ABBR: Record<string, string> = {
  SG: 'SGT',
  MY: 'MYT',
  ID: 'WIB',
  TH: 'ICT',
  VN: 'ICT',
  PH: 'PHT',
  TW: 'TWT',
  AU: 'AEDT',
  KR: 'KST',
};

// Source of truth: `.claude/handoff/ui/SBData.jsx` (`GLOBAL_CURRENCIES`).
// Synced 2026-05-30 — full 17-currency list (was 10, missing the European /
// Northeast-Asia / India set).
export const GLOBAL_CURRENCIES = [
  'SGD',
  'USD',
  'MYR',
  'IDR',
  'PHP',
  'THB',
  'VND',
  'TWD',
  'HKD',
  'KRW',
  'JPY',
  'CNY',
  'AUD',
  'NZD',
  'EUR',
  'GBP',
  'INR',
];
